import Signup from '../components/presentations/signup'

const SignUpContainer = () => {
  return <Signup />
}

export default SignUpContainer
